// services/coupon.service.ts
import axiosInstance from "../axios.service"
import BaseUrl from "../url.service"

const serverUrl = `${BaseUrl}/webCoupon`

export const addCouponApi = (formData) => {
  return axiosInstance.post(`${serverUrl}/add`, formData)
}

export const getCouponsApi = (query) => {
  return axiosInstance.get(`${serverUrl}/getCoupon${query ? `?${query}` : ""}`)
}

export const updateCouponApi = (
  id,
  formData
) => {
  return axiosInstance.put(`${serverUrl}/update/${id}`, formData)
}

export const deleteCouponApi = (id) => {
  return axiosInstance.delete(`${serverUrl}/delete/${id}`)
}
